import { render, staticRenderFns } from "./PandI.vue?vue&type=template&id=44d5aa44&scoped=true&"
import script from "./PandI.vue?vue&type=script&lang=js&"
export * from "./PandI.vue?vue&type=script&lang=js&"
import style0 from "./PandI.vue?vue&type=style&index=0&id=44d5aa44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d5aa44",
  null
  
)

export default component.exports